import React, { useEffect, useState } from "react";

/**
 * Atmospheric particles — small soft floating dots for cinematic depth.
 * CSS-only, GPU-friendly, no canvas overhead.
 */
export default function AtmosphericParticles({ count = 24, className = "" }) {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    const items = Array.from({ length: count }).map((_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: 1 + Math.random() * 2.5,
      duration: 14 + Math.random() * 18,
      delay: -Math.random() * 20,
      opacity: 0.2 + Math.random() * 0.6,
      hue: Math.random() > 0.5 ? "blue" : "gold",
    }));
    setParticles(items);
  }, [count]);

  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      {particles.map((p) => (
        <span
          key={p.id}
          className="absolute rounded-full"
          style={{
            left: `${p.x}%`,
            top: `${p.y}%`,
            width: p.size,
            height: p.size,
            background: p.hue === "blue"
              ? `rgba(0, 170, 255, ${p.opacity})`
              : `rgba(217, 203, 179, ${p.opacity * 0.7})`,
            boxShadow: p.hue === "blue"
              ? `0 0 ${p.size * 3}px rgba(0,170,255,${p.opacity * 0.8})`
              : `0 0 ${p.size * 3}px rgba(198,168,107,${p.opacity * 0.6})`,
            animation: `particleFloat ${p.duration}s ease-in-out ${p.delay}s infinite`,
          }}
        />
      ))}
      <style>{`
        @keyframes particleFloat {
          0%, 100% { transform: translate(0, 0); opacity: 0.4; }
          25% { transform: translate(20px, -30px); opacity: 0.9; }
          50% { transform: translate(-15px, -60px); opacity: 0.6; }
          75% { transform: translate(25px, -30px); opacity: 0.8; }
        }
      `}</style>
    </div>
  );
}
